<template>
  <b-navbar-nav class="nav align-items-center mr-auto">
    <div
      v-if="!mostrarSelecao"
      class="d-sm-flex d-none user-nav"
    >
      <p
        class="user-name font-weight-bolder mb-0"
        @click="onMostrarSelecao"
      >
        {{ getEmpresaDescricao() }}
      </p>
    </div>

    <div
      v-else
      style="max-width:calc(100vw/4);width:calc(100vw/4);"
      @blur.prevent="onMostrarSelecao"
    >
      <empresa-usuario-externo-select
        v-model="value"
        class="w-100"
        :show-label="false"
        @select="alterarEmpresaSelecionada"
      />
    </div>
  </b-navbar-nav>
</template>

<style lang="scss">
.empresa-select .vs__dropdown-option--selected .company-identification {
  & span {
    color: white;
    border: 1px solid white !important;
  }
}
.company-identification {
  & span {
    font-size: 0.65rem;
    color: var(--primary);
    font-weight: 700;
    background-color: transparent;
    border: 1px solid var(--primary) !important;
    border-radius: 2px;
    padding: 0.1rem 0.2rem;
  }
}
</style>

<script>
import '@core/scss/vue/libs/vue-select.scss'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EmpresaExterna',
  components: {
    EmpresaUsuarioExternoSelect: () => import('@/shared/components/empresa-usuario-externo-select/EmpresaUsuarioExternoSelect.vue'),
  },
  data() {
    return {
      mostrarSelecao: false,
    }
  },
  computed: {
    ...mapGetters('empresaExGlobal', ['empresa', 'escolherEmpresa']),
    value: {
      set(value) {
        this.setEmpresa(value)
      },
      get() {
        return this.empresa
      },
    },
  },
  methods: {
    ...mapActions('empresaExGlobal', ['setEmpresa']),
    alterarEmpresaSelecionada() {
      this.mostrarSelecao = false
      window.location.reload()
    },
    onMostrarSelecao() {
      this.mostrarSelecao = this.escolherEmpresa
    },
    getEmpresaDescricao() {
      const { empresa } = this
      return empresa && empresa.id ? `${empresa.cadastroFederal} - ${empresa.razaoSocial}` : 'Selecione uma empresa'
    },
  },
}
</script>
